export default {
    available: "Proizvod je dostupan",
    unavailable: "Proizvod nije dostupan",
    code: "Šifra proizvoda",
    size: "Veličina",
    color: "Boja",
    buy: "Kupi odmah",
    addToCart: "Dodaj u korpu",
    addedIntoCart: "proizvod(a) je dodato u korpu",
    viewCart: "Pogledaj korpu i naruci",
    continueShopping: "Nastavite kupovinu",
    askSeller: "Pitaj prodavca",
    infoMsg: {
        productDeliveresAndSells: "Proizvod isporučuje i prodaje",
        trgujShowsOffer: "Platforma Trguj.me prikazuje samo ponudu.",
        delivery: 'Okvirni datum isporuke:'
    }
};
